import React, { Component } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const gameList = [
  {
    title: "Spadegaming",
    href: "/ทำความรู้จัก-spadegaming-ufac4/",
    img: "/build/web/igame-index-lobby-wm/img/photo_๒๐๒๕-๑๐-๑๒_๒๐-๒๘-๕๔-2.jpg",
  },
  {
    title: "joker",
    href: "/5-กลยุทธ์พิชิตjoker/",
    img: "/build/web/igame-index-lobby-wm/img/photo_๒๐๒๕-๑๐-๑๒_๒๐-๒๘-๕๔.jpg",
  },
  {
    title: "ufaslot",
    href: "/สล็อตออนไลน์-2024-ที่ดี/",
    img: "/build/web/igame-index-lobby-wm/img/photo_๒๐๒๕-๑๐-๑๒_๒๐-๒๘-๕๓-7.jpg",
  },
  {
    title: "pg slot",
    href: "/pgslotเกมสล็อตออนไลน์ชั้นนำ/",
    img: "/build/web/igame-index-lobby-wm/img/photo_๒๐๒๕-๑๐-๑๒_๒๐-๒๘-๕๓-6.jpg",
  },
  {
    title: "red tiger",
    href: "/red-tiger/",
    img: "/build/web/igame-index-lobby-wm/img/photo_๒๐๒๕-๑๐-๑๒_๒๐-๒๘-๕๓-5.jpg",
  },
  {
    title: "sa gaming",
    href: "/sa/",
    img: "/build/web/igame-index-lobby-wm/img/photo_๒๐๒๕-๑๐-๑๒_๒๐-๒๘-๕๓-4.jpg",
  },
  {
    title: "sexy baccarat",
    href: "/sexy-gaming/",
    img: "/build/web/igame-index-lobby-wm/img/2568-10-12-23.38.57.jpg",
  },
];

const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 5, // 👈 ให้เหมือน owl
  slidesToScroll: 1,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 3000,
  arrows: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 4 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 2 },
    },
  ],
};

class GameSlider extends Component {
  render() {
    return (
      <div className="game-slider-wrap">
        <Slider {...settings}>
          {gameList.map((item, index) => (
            <div key={index} className="game-item">
              <div className="list_p4xx Parent">
                <a href={item.href} title={item.title}>
                  <figure className="imghvr-fold-right">
                    <img src={item.img} alt={item.title} />
                    <figcaption>
                      <img src={item.img} alt={item.title} />
                    </figcaption>
                  </figure>
                </a>
              </div>
            </div>
          ))}
        </Slider>

        <style>{`
          .game-slider-wrap {
            width: 100%;
            padding: 10px 0;
          }

          .game-item {
            padding: 0 5px;
          }

          .game-item img {
            width: 100%;
            display: block;
          }

          .slick-list {
            margin: 0 -5px;
          }

          .slick-prev {
            left: 0;
            z-index: 10;
          }

          .slick-next {
            right: 0;
            z-index: 10;
          }

          .slick-prev:before,
          .slick-next:before {
            font-size: 24px;
          }
        `}</style>
      </div>
    );
  }
}

export default GameSlider;